import { render, staticRenderFns } from "./TargetingForm.vue?vue&type=template&id=0904b942&"
import script from "./TargetingForm.vue?vue&type=script&lang=ts&"
export * from "./TargetingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports